import { render, staticRenderFns } from "./MailsPerformView.vue?vue&type=template&id=3ca799e3&scoped=true"
import script from "./MailsPerformView.vue?vue&type=script&lang=js"
export * from "./MailsPerformView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca799e3",
  null
  
)

export default component.exports